import styled from '@emotion/styled';

export const StyledButton = styled.button`
  background: linear-gradient(180deg, #3fd5ce, #07b0a9 58.85%, #049c96 97.02%);
`;
